import { BlockGrid, Boundary, SectionGrid } from '../types';

export function filterPossibleSectionBoundaries(boundaries: Boundary[], sectionGrids: SectionGrid[]): Boundary[] {
  return boundaries.filter((boundary) => {
    if (boundary.orientation === 'vertical') {
      return false;
    }
    return true;
  });
}
